import { Link } from 'gatsby';
import SEO from "../../../../src/components/seo";
import * as React from 'react';
export default {
  Link,
  SEO,
  React
};